// extracted by mini-css-extract-plugin
export default {"Main":"DefaultLayout_Main__uOdcR"};